import { displayFunctions } from '../../../utils/chartsUtils';

export const data = {
  plots: {
    business_profile_interactions: {
      addAdditionalPlots: true,
      business_profile_interactions: {
        trend: 1,
        values: [15, 20, 22, 24, 27, 29, 32],
        displayValue: 169
      }
    },
    impressions_desktop: {
      maps: {
        trend: 0,
        values: [25, 30, 35, 40, 45, 50, 55],
        displayValue: 280
      },
      search: {
        trend: 1,
        values: [30, 35, 40, 45, 50, 55, 60],
        displayValue: displayFunctions.sum([30, 35, 40, 45, 50, 55, 60])
      }
    },
    impressions_mobile: {
      maps: {
        trend: 0,
        values: [40, 45, 50, 55, 60, 65, 70],
        displayValue: displayFunctions.sum([40, 45, 50, 55, 60, 65, 70])
      },
      search: {
        trend: 1,
        values: [45, 50, 55, 60, 65, 70, 75],
        displayValue: displayFunctions.sum([45, 50, 55, 60, 65, 70, 75])
      }
    },
    calls: {
      calls: {
        trend: 0,
        values: [5, 6, 7, 8, 9, 10, 11],
        displayValue: displayFunctions.sum([5, 6, 7, 8, 9, 10, 11])
      }
    },
    messages: {
      messages: {
        trend: 1,
        values: [3, 4, 5, 6, 7, 8, 9],
        displayValue: displayFunctions.sum([3, 4, 5, 6, 7, 8, 9])
      }
    },
    bookings: {
      bookings: {
        trend: 0,
        values: [2, 3, 4, 5, 6, 7, 8],
        displayValue: displayFunctions.sum([2, 3, 4, 5, 6, 7, 8])
      }
    },
    directions: {
      directions: {
        trend: 1,
        values: [10, 12, 14, 16, 18, 20, 22],
        displayValue: displayFunctions.sum([10, 12, 14, 16, 18, 20, 22])
      }
    },
    website_clicks: {
      website_clicks: {
        trend: 0,
        values: [8, 9, 10, 11, 12, 13, 14],
        displayValue: displayFunctions.sum([8, 9, 10, 11, 12, 13, 14])
      }
    }
  },
  additionalData: {
    posts_per_day: {
      trend: -1,
      values: [0, 0, 1, 0, 0, 2, 1],
      displayValue: displayFunctions.sum([0, 0, 1, 0, 0, 2, 1])
    }
  },
  dates: getLastSevenDays()
};

function getLastSevenDays(): any {
  const dates = [];
  for (let i = 1; i < 8; i++) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(date.toISOString().split('T')[0] + 'T00:00:00+00:00');
  }
  return dates.reverse();
}
